export type SupportedLanguage = "en" | "ru" | "fr" | "es";

export interface LanguageInfo {
  code: SupportedLanguage;
  nativeName: string;
  englishName: string;
}

export const SUPPORTED_LANGUAGES: readonly LanguageInfo[] = [
  { code: "en", nativeName: "English", englishName: "English" },
  { code: "ru", nativeName: "Русский", englishName: "Russian" },
  { code: "fr", nativeName: "Français", englishName: "French" },
  { code: "es", nativeName: "Español", englishName: "Spanish" }
] as const;

export const DEFAULT_LANGUAGE: SupportedLanguage = "en";

export function isSupportedLanguage(value: unknown): value is SupportedLanguage {
  return typeof value === "string" && SUPPORTED_LANGUAGES.some(({ code }) => code === value);
}

export function normalizeLanguage(value: unknown): SupportedLanguage {
  return isSupportedLanguage(value) ? value : DEFAULT_LANGUAGE;
}

export function getLanguageEnglishName(value: unknown): string {
  const language = normalizeLanguage(value);
  return SUPPORTED_LANGUAGES.find(({ code }) => code === language)?.englishName ?? "English";
}
